import React, {Component} from "react"
import {connect} from "react-redux"
import {addFlashMessage} from "~/actions/flashMessages"
import {resetPassword} from "../../actions/authActions"

import {Form, FormSection, Field} from "~/components/"
import {withTranslation} from "react-i18next"

class ResetPasswordForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      password: "",
      passwordConfirmation: "",
      errors: {},
      isLoading: false
    }
  }

  submit(params) {
    this.setState({errors: {}})
    const {password, passwordConfirmation} = this.state
    const {token} = this.props

    return new Promise((resolve, reject) => {
      this.props
        .resetPassword({password, passwordConfirmation, token})
        .then(() => {
          resolve()
          window.location.pathname = "/"
        })
        .catch(err => {
          if (err.response) {
            this.setState({
              errors: err.response.data.errors
            })
          } else {
            console.log(err)
            this.setState({
              errors: {
                global: this.props.t("errorMessage")
              }
            })
          }
          reject(err)
        })
    })
  }

  render() {
    const {password, passwordConfirmation, errors} = this.state
    return (
      <div>
        <Form
          onSubmit={this.submit.bind(this)}
          submitLabel={this.props.t("resetPassword.submit")}
          getDefaultValue={(name, x) => {
            return ""
          }}
          globalError={errors ? errors.global : null}
        >
          <FormSection label={this.props.t("resetPassword.title")}>
            <Field
              label={this.props.t("resetPassword.password")}
              type="password"
              name="password"
              value={password}
              onChange={e => this.setState({password: e.target.value})}
            />
            <Field
              label={this.props.t("resetPassword.passwordConfirmation")}
              type="password"
              name="passwordConfirmation"
              value={passwordConfirmation}
              onChange={e =>
                this.setState({passwordConfirmation: e.target.value})
              }
            />
          </FormSection>
        </Form>
      </div>
    )
  }
}

export default withTranslation()(
  connect(null, {addFlashMessage, resetPassword})(ResetPasswordForm)
)



// WEBPACK FOOTER //
// ./src/components/forms/ResetPasswordForm.js